





























































import { Component, Vue, Prop } from "vue-property-decorator";
import { vxm } from '@/store.vuex';

@Component
export default class AccountLockedForm extends Vue {
  @Prop({ default: '' }) username;
  @Prop({ default: () => {} }) sendOtp;

  cancel() {
    this.$router.back();
  }

  keymonitor() {
    alert();
  }

  get supportEmail(): string {
    return vxm.configs.getGlobalConfigValue('SUPPORT_EMAIL') || vxm.utility.supportEmail;
  }

  get showSupportPhoneNumber(): boolean {
    return  vxm.configs.getGlobalConfigValue('SUPPORT_PHONE_NUMBER') ? true : false;
  }

  get supportPhoneNumber(): string {
    return (
      vxm.configs.getGlobalConfigValue('SUPPORT_PHONE_NUMBER') || vxm.utility.supportPhoneNo
    );
  }
}
